import { render, staticRenderFns } from "./CardMaisFiltros.vue?vue&type=template&id=69a0ce0f&scoped=true"
import script from "./CardMaisFiltros.vue?vue&type=script&lang=ts&setup=true"
export * from "./CardMaisFiltros.vue?vue&type=script&lang=ts&setup=true"
import style0 from "./CardMaisFiltros.vue?vue&type=style&index=0&id=69a0ce0f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69a0ce0f",
  null
  
)

export default component.exports